<script setup lang="ts">
import { computed, ref } from 'vue'
import fallbackImage from '@/assets/error-image.svg'

interface Props {
  src?: string,
  alt?: string,
  width?: string,
  height?: string,
}
const props = defineProps<Props>()

const _source = ref<string>(props.src || fallbackImage)

const _class = computed(() => {
  return 'cs_image'
})

const _style = computed(() => {
  return ''
})

const onError = () => {
  _source.value = fallbackImage
}

</script>

<template>
  <img
    :src="_source"
    :alt="props.alt || 'default image'"
    :width="props.width"
    :height="props.height"
    :class="_class"
    :style="_style"
    @error="onError"/>
</template>

<style scoped>

</style>
